<template>
  <v-container class="py-8">
    <!-- Modal de Loading -->
    <v-dialog v-model="loadingSalvar" persistent max-width="300">
      <v-card class="pa-6 text-center">
        <v-progress-circular indeterminate color="primary" size="48" class="mb-4" />
        <div class="mb-2 font-weight-medium">Salvando avaliação...</div>
        <div class="text--secondary">Por favor, aguarde.</div>
      </v-card>
    </v-dialog>

    <!-- Modal de Sucesso/Erro -->
    <v-dialog v-model="showModal" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ modalTipo === 'success' ? 'Sucesso' : 'Erro' }}</v-card-title>
        <v-card-text>
          <v-alert :type="modalTipo" dense>{{ modalMsg }}</v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Modal pergunta comentário -->
    <v-dialog v-model="dialogComentario" persistent max-width="440">
      <v-card>
        <v-card-title class="primary white--text pa-4">
          <v-icon color="white" class="mr-2">mdi-comment-question-outline</v-icon>
          Registro de Comentário
        </v-card-title>
        <v-card-text class="pa-6 text-center">
          <v-icon color="primary" size="52" class="mb-4">mdi-pencil-box-outline</v-icon>
          <p class="body-1">Deseja registrar algum comentário por escrito?</p>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-btn color="grey darken-1" text @click="encerrarSemComentario">
            <v-icon left>mdi-close</v-icon>
            Não
          </v-btn>
          <v-spacer />
          <v-btn color="primary" @click="irParaComentario">
            <v-icon left>mdi-pencil</v-icon>
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row justify="center">
      <v-col cols="12" md="8" lg="6">
        <!-- Header Card -->
        <v-card class="mb-6" elevation="2">
          <v-card-title class="primary white--text text-center">
            <v-icon color="white" class="mr-2">mdi-clipboard-list</v-icon>
            Avaliação Institucional
          </v-card-title>
          <v-card-text class="text-center pa-4">
            <h4 class="mb-2 text--primary">{{ param.pessoa.instituicao }}</h4>
            <v-chip color="primary" outlined>{{ param.Selecionado.anexo }}</v-chip>
          </v-card-text>
        </v-card>

        <!-- Return Button -->
        <v-card class="mb-4" elevation="1">
          <v-btn text color="primary" @click="returnarInicio" class="ma-2">
            <v-icon left>mdi-keyboard-return</v-icon>
            Retornar ao Início
          </v-btn>
        </v-card>

        <!-- Questions -->
        <v-card v-for="(item, index) in this.quastoes" :key="item.ordem" class="mb-4" elevation="2">
          <v-card-title :class="parseInt(item.resposta) > 0 ? 'light-green lighten-4' : 'grey lighten-4'" class="py-3 transition-colors">
            <span class="body-1 font-weight-medium">
              <v-icon :color="parseInt(item.resposta) > 0 ? 'success' : 'grey'" class="mr-2">
                {{ parseInt(item.resposta) > 0 ? 'mdi-check-circle' : 'mdi-circle-outline' }}
              </v-icon>
              Questão {{ item.ordem }}
            </span>
          </v-card-title>
          <v-card-text class="pa-4">
            <p class="body-1 mb-4 question-text">{{ item.descricao }}</p>

            <v-radio-group v-model="item.resposta" :name="`opcao${item.ordem}`" class="mt-0">
              <v-radio v-for="opc in item.opcao" :key="opc.ordem" :label="opc.descricao" :value="opc.id" color="primary" class="mb-2"></v-radio>
            </v-radio-group>
          </v-card-text>

          <!-- Progress indicator -->
          <v-progress-linear :value="((index + 1) / quastoes.length) * 100" color="primary" height="2"></v-progress-linear>
        </v-card>

        <!-- Save Button -->
        <v-card class="mt-6" elevation="2" v-if="quastoes.length > 0">
          <v-card-text class="pa-4">
            <v-btn :disabled="!habilitarSalvar" :color="habilitarSalvar ? 'success' : 'grey'" @click="salvar" block large elevation="2">
              <v-icon left>mdi-check-circle</v-icon>
              {{ habilitarSalvar ? 'Finalizar Avaliação' : `Responda todas as questões (${questoesRespondidas}/${quastoes.length})` }}
            </v-btn>

            <div class="text-center mt-3">
              <v-chip :color="habilitarSalvar ? 'success' : 'warning'" small outlined>
                {{ questoesRespondidas }} de {{ quastoes.length }} questões respondidas
              </v-chip>
            </div>
          </v-card-text>
        </v-card>

        <!-- Loading State -->
        <v-card v-if="quastoes.length === 0" class="text-center pa-8" elevation="2">
          <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
          <p class="mt-4 text--secondary">Carregando questionário...</p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  name: 'questionarios',
  data: () => ({
    quastoes: [],
    loadingSalvar: false,
    showModal: false,
    modalMsg: '',
    modalTipo: 'success',
    dialogComentario: false,
  }),
  components: {},
  filters: {},
  computed: {
    ...mapGetters({ param: 'avaliacao/param' }),
    questoesRespondidas() {
      return this.quastoes.filter((i) => parseInt(i.resposta) > 0).length;
    },
    habilitarSalvar() {
      return this.questoesRespondidas === this.quastoes.length && this.quastoes.length > 0;
    },
  },
  methods: {
    ...mapMutations({ setPessoa: 'avaliacao/setPessoa' }),
    ...mapActions({ requestQuestao: 'avaliacao/requestQuestao', requestResponder: 'avaliacao/requestResponder' }),
    async load() {
      let id = this.param.Selecionado.id;
      let d = await this.requestQuestao({ id_questionario: id });
      let data = d.data;
      data[0].map((i) => {
        i.opcao = data[1];
        i.resposta = 0;
      });
      this.quastoes = data[0];
    },
    returnarInicio() {
      this.param.listaApto = [];
      this.param.cpf = '';
      this.$router.push('/');
    },
    async salvar() {
      this.loadingSalvar = true;
      let j = {};
      j.cabecalho = {
        id_questionario: this.param.Selecionado.id,
        cgm: this.param.pessoa.cgm,
        id_responsavel: this.param.pessoa.id_responsavel,
        cpf: this.param.pessoa.cpf,
        id_instituicao: this.param.pessoa.id_instituicao,
      };

      let r = [];
      this.quastoes.map((i) => {
        r.push(`${i.ordem}:${i.resposta}`);
      });
      j.resposta = r;
      try {
        const resp = await this.requestResponder(j);
        console.log('o que retornou......', resp);
        this.exibirMensagemResposta(resp);
      } catch (e) {
        this.exibirModalMensagem('Erro ao salvar avaliação. Tente novamente.', 'error');
      } finally {
        this.loadingSalvar = false;
      }
    },
    exibirModalMensagem(msg, tipo = 'success') {
      this.modalMsg = msg;
      this.modalTipo = tipo;
      this.showModal = true;

      if (tipo === 'error') {
        setTimeout(() => {
          this.showModal = false;
        }, 2200);
        return;
      }

      setTimeout(() => {
        this.showModal = false;
        this.dialogComentario = true;
      }, 2000);
    },
    encerrarSemComentario() {
      this.dialogComentario = false;
      this.$store.commit('avaliacao/setSelecionado', null);
      this.setPessoa(null);
      this.$router.push({ name: 'initPage' });
    },
    irParaComentario() {
      this.dialogComentario = false;
      this.$router.push({ name: 'ComentarioAvaliacao' });
    },
    exibirMensagemResposta(resp) {
      if (resp && resp.data) {
        if (resp.data.error) {
          this.exibirModalMensagem(resp.data.error, 'error');
        } else if (resp.data.success) {
          this.exibirModalMensagem(resp.data.success, 'success');
        }
      }
    },
  },
  mounted: function () {
    this.load();
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 8px !important;
}

.v-card-title {
  font-weight: 500;
}

.v-radio >>> .v-label {
  font-size: 14px;
  line-height: 1.4;
}

.v-btn {
  text-transform: none !important;
  font-weight: 500;
}

.transition-colors {
  transition: background-color 0.3s ease;
}

.question-text {
  text-align: justify !important;
  text-justify: inter-word;
  line-height: 1.6;
}
</style>
